import {
  ActiveI9Item,
  isReverificationReviewReason,
} from '../../../application/domain/entities/ActiveI9Item';
import { LocationItem } from '../../../application/domain/entities/LocationItem';
import { ActiveI9ResponseItemDto } from '../dto/res/ActiveI9ResponseItemDto';
import { LocationItemDto } from '../dto/res/LocationItemDto';
import { I9Status, I9_STATUS_DISPLAY } from '../../../application/domain/enums/I9Status';

export class ActiveI9Mapper {
  static toDomain(dto: ActiveI9ResponseItemDto): ActiveI9Item {
    const statusDisplay = I9_STATUS_DISPLAY[dto.status as I9Status] || dto.status;

    return {
      i9FormId: dto.i9FormId,
      accountName: dto.accountName,
      firstName: dto.firstName,
      lastName: dto.lastName,
      employeeName: `${dto.firstName} ${dto.lastName}`,
      ssn: dto.ssn,
      email: dto.section1Email,
      status: dto.status,
      statusDisplay: statusDisplay,
      location: dto.locationName,
      hireDate: dto.hireDate,
      signatureDate: dto.signatureDate,
      nextAction: dto.nextAction,
      canArchive: dto.canArchive ?? false,
      referenceNumber: dto.referenceNumber,
      errorCount: dto.errorCount ?? null,
      createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
      dateSent: dto.dateSent ? new Date(dto.dateSent) : undefined,
      // An unknown reason reads as none rather than showing a raw code in the table.
      reviewReason: isReverificationReviewReason(dto.reviewReason) ? dto.reviewReason : null,
    };
  }

  static toLocationDomain(dto: LocationItemDto): LocationItem {
    return {
      value: dto.locationId,
      label: dto.locationName,
    };
  }
}
